import { BaseSessionCtrl } from '~/controllers/base-session.controller';
import { IUserResponse } from '~/types/server.types';
import { GlobalCXContextValue } from '~/components/ClientExperience/providers/global-context/global-cx.context';

export class SessionCXCtrl extends BaseSessionCtrl {
    globalContext: GlobalCXContextValue;

    constructor(globalContext: GlobalCXContextValue, appBasePath: string) {
        super(globalContext, appBasePath);

        this.globalContext = globalContext;
    }

    login(user) {
        this.localLogin(user);
    }

    crossAppLogin(user: IUserResponse) {
        const { jStorageService } = this.globalContext;

        if (!user) {
            return;
        }

        jStorageService.setMultiple({
            HB_API_VERSION: user.api_version,
            HB_AUTH_TOKEN: user.authentication_token,
            HB_AUTH_USER_ID: user._id,
            HB_CURR_USER: user
        });
        this.login(user);
    }
}
